/**
 * Servicio principal de Firebase usando AngularFire
 * Inicializa Firebase y proporciona acceso a los servicios
 */
import { Injectable, inject } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { Firestore } from '@angular/fire/firestore';
import { Storage } from '@angular/fire/storage';
import { Analytics } from '@angular/fire/analytics';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {
  // Inyectar servicios de AngularFire
  private _auth = inject(Auth);
  private _firestore = inject(Firestore, { optional: true });
  private _storage = inject(Storage, { optional: true });
  private _analytics = inject(Analytics, { optional: true });

  /**
   * Obtiene la instancia de Firebase Auth
   */
  getAuth(): Auth {
    return this._auth;
  }

  /**
   * Obtiene la instancia de Firestore
   */
  getFirestore(): Firestore | null {
    return this._firestore || null;
  }

  /**
   * Obtiene la instancia de Storage
   */
  getStorage(): Storage | null {
    return this._storage || null;
  }

  /**
   * Obtiene la instancia de Analytics
   */
  getAnalytics(): Analytics | null {
    return this._analytics || null;
  }
}

